export default __webpack_public_path__ + "noofupload-light-icon.svg";